import { render, staticRenderFns } from "./previewPDF.vue?vue&type=template&id=65086734"
import script from "./previewPDF.vue?vue&type=script&lang=js"
export * from "./previewPDF.vue?vue&type=script&lang=js"
import style0 from "./previewPDF.vue?vue&type=style&index=0&id=65086734&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports